import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { getSearchUrl } from '@videoblocks/shared-components/dist/mjs/components/Shared/SearchUtils';

import {
  selectAuthPermissions,
  selectHasAnySubscription,
  selectUseSnapshotsUI,
  selectEnableSearchHistory,
} from '../../../../auth/AuthSelectors';
import { searchOrigins } from '../../../Navigation/constants';
import { SearchFilterContentTypes } from '../../../Shared/enums';
import { SearchOption } from '../../../Shared/types';
import { selectIsEnterpriseMember } from '../../selectors/searchSelectors';
import ProminentSearchNav from './ProminentSearchNav';

interface ProminentSearchContainerProps {
  imagesUrl: string;
  contentTypes: SearchOption[];
  contentType: SearchFilterContentTypes;
  setContentType: (newContentType: SearchFilterContentTypes) => void;
  showDropdown?: boolean;
  showContentToggles?: boolean;
}

const ProminentSearchContainer = ({
  imagesUrl,
  contentTypes,
  contentType,
  setContentType,
  showDropdown = true,
  showContentToggles,
}: ProminentSearchContainerProps) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const handleSubmit = (contentType: string, searchTerm: string) => {
    const searchUrl = getSearchUrl({
      contentType: contentType as SearchFilterContentTypes,
      searchTerm,
      searchOrigin: searchOrigins.SEARCH_BAR,
    });
    window.location.href = searchUrl;
  };

  const userHasAnySubscription = useSelector(selectHasAnySubscription);
  const isEnterpriseMember = useSelector(selectIsEnterpriseMember);
  const { pproPluginEnabled } = useSelector(selectAuthPermissions);
  const useSnapshotsUI = useSelector(selectUseSnapshotsUI);
  const enableSearchHistory = useSelector(selectEnableSearchHistory);

  return (
    <ProminentSearchNav
      contentType={contentType}
      onDropdownChange={(contentType) => {
        setContentType(contentType as SearchFilterContentTypes);
      }}
      onSubmit={handleSubmit}
      searchTerm={''}
      userHasAnySubscription={userHasAnySubscription}
      isEnterpriseMember={isEnterpriseMember}
      pproPluginEnabled={pproPluginEnabled}
      isSearchAppLoaded={() => false}
      imagesUrl={imagesUrl}
      prominentSearchOptions={contentTypes}
      contentTypeFromPrevious={
        contentType || SearchFilterContentTypes.All_videos_content_type
      }
      showDropDown={showDropdown}
      showContentToggles={showContentToggles}
      setShowSuggestions={setShowSuggestions}
      showSuggestions={showSuggestions}
      useSnapshots={useSnapshotsUI}
      enableSearchHistory={enableSearchHistory}
    />
  );
};

export default ProminentSearchContainer;
